/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
const STORAGE_KEYS = {
    token: "authToken",
    role: "authRole",
    user: "user",
    permissions: "permissions",
    isTenantOwner: "isTenantOwner",
  };
  
  export const storage = {
    get() {
      try {
        return {
          token: localStorage.getItem(STORAGE_KEYS.token),
          authRole: localStorage.getItem(STORAGE_KEYS.role),
          user: JSON.parse(localStorage.getItem(STORAGE_KEYS.user)),
          permissions: JSON.parse(localStorage.getItem(STORAGE_KEYS.permissions)) || {},
          isTenantOwner: localStorage.getItem(STORAGE_KEYS.isTenantOwner) === "true",
        };
      } catch {
        return null;
      }
    },
  
    set({ token, authRole, user, permissions, isTenantOwner }) {
      localStorage.setItem(STORAGE_KEYS.token, token);
      localStorage.setItem(STORAGE_KEYS.role, authRole);
      localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user));
      localStorage.setItem(STORAGE_KEYS.permissions, JSON.stringify(permissions || {}));
      localStorage.setItem(
        STORAGE_KEYS.isTenantOwner,
        isTenantOwner ? "true" : "false"
      );
    },
  
    clear() {
      Object.values(STORAGE_KEYS).forEach((key) =>
        localStorage.removeItem(key)
      );
    },
  };
  